import React from 'react';
import { pick, prop } from 'ramda';
import { Helmet } from 'react-helmet-async';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { IPageState } from '@core/js/components/system/Page/store/types';

import * as helpers from '@core/js/components/system/Page/helpers';

export const PageSEOTags: React.FC<{ page?: IPageState; noindex: boolean }> = ({ page, noindex = false }) => {
    const lang = useUserSelector(prop('lang'));
    const { allowedLocales, defaultLocale, seo: { useTrailingSlash } } = useAppSelector(pick(['allowedLocales', 'defaultLocale', 'seo']));

    if (!page) {
        return null;
    }

    const alternateLinks = helpers.getAlternateLinks({ page, allowedLocales, defaultLocale, useTrailingSlash });
    const canonicalLinkUrl = helpers.getCanonicalLinkUrl({ page, defaultLocale, lang, useTrailingSlash });
    const { title, robots, keywords, description } = page;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="robots" content={noindex ? 'noindex' : robots} /> {/* Sportium changes */}
            <meta name="keywords" content={keywords} />
            <meta name="description" content={description} />
            <meta name="referrer" content="no-referrer-when-downgrade" />
            {alternateLinks.map(alternateLink => (
                <link
                    rel={'alternate'}
                    href={alternateLink.href}
                    key={alternateLink.hrefLang}
                    hrefLang={alternateLink.hrefLang}
                />
            ))}
            <link rel="canonical" href={canonicalLinkUrl} />
        </Helmet>
    );
};
